exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] .myuUlGvP6GrUPfsb4uqkv .ms-Dialog-action,html[dir] .myuUlGvP6GrUPfsb4uqkv .ms-Dialog-actionsRight{margin:initial}.myuUlGvP6GrUPfsb4uqkv ._3bCHnE_YY1u16ynk14CQd3{width:100%}html[dir] .myuUlGvP6GrUPfsb4uqkv ._3bCHnE_YY1u16ynk14CQd3{margin:10px 0}", ""]);
// Exports
exports.locals = {
	"dialog": "myuUlGvP6GrUPfsb4uqkv",
	"footerButton": "_3bCHnE_YY1u16ynk14CQd3"
};